import { t } from "@lingui/macro";
import { BookOpen, Building2, Package, Scale } from "lucide-react";
import { Link } from "react-router";

import { IconBadge, PageHero, Section } from "../_components/page-shell";

export const SitemapPage = () => {
  const linkClass = "text-muted-foreground hover:text-primary transition-colors";
  const columnClass = "rounded-2xl border border-border bg-background p-6";
  const headingClass =
    "text-sm font-semibold uppercase tracking-wider text-neutral-800 dark:text-neutral-100";

  return (
    <>
      <PageHero
        eyebrow={t`Sitemap`}
        title={t`Everything on Izicvs`}
        subtitle={t`A complete overview of our pages, all in one place.`}
      />

      <Section>
        <div className="grid gap-6 md:grid-cols-4">
          <div className={columnClass}>
            <IconBadge icon={Package} className="mb-4" />
            <h2 className={headingClass}>{t`Product`}</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/pricing" className={linkClass}>
                  {t`Pricing`}
                </Link>
              </li>
              <li>
                <a href="/#features" className={linkClass}>
                  {t`Features`}
                </a>
              </li>
              <li>
                <a href="/#templates" className={linkClass}>
                  {t`Templates`}
                </a>
              </li>
              <li>
                <Link to="/ats-checker" className={linkClass}>
                  {t`ATS Checker`}
                </Link>
              </li>
            </ul>
          </div>

          <div className={columnClass}>
            <IconBadge icon={BookOpen} className="mb-4" />
            <h2 className={headingClass}>{t`Resources`}</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/guides" className={linkClass}>
                  {t`Career Guides`}
                </Link>
              </li>
              <li>
                <Link to="/faq" className={linkClass}>
                  {t`FAQ`}
                </Link>
              </li>
              <li>
                <Link to="/help" className={linkClass}>
                  {t`Help Center`}
                </Link>
              </li>
            </ul>
          </div>

          <div className={columnClass}>
            <IconBadge icon={Building2} className="mb-4" />
            <h2 className={headingClass}>{t`Company`}</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/about" className={linkClass}>
                  {t`About`}
                </Link>
              </li>
              <li>
                <Link to="/contact" className={linkClass}>
                  {t`Contact`}
                </Link>
              </li>
              <li>
                <Link to="/feedback" className={linkClass}>
                  {t`Suggestions`}
                </Link>
              </li>
            </ul>
          </div>

          <div className={columnClass}>
            <IconBadge icon={Scale} className="mb-4" />
            <h2 className={headingClass}>{t`Legal`}</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/privacy" className={linkClass}>
                  {t`Privacy Policy`}
                </Link>
              </li>
              <li>
                <Link to="/terms" className={linkClass}>
                  {t`Terms of Use`}
                </Link>
              </li>
              <li>
                <Link to="/cookies" className={linkClass}>
                  {t`Cookie Policy`}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Section>
    </>
  );
};
